//#region types
import { ReceiptFormTypes } from "models/formTypes";
import { BaseFormExpandableStepProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { CostForwardingSection } from "components/costForwardingMarking";
//#endregion

const ReceiptTodoCostForwardingSection: React.FC<BaseFormExpandableStepProps<ReceiptFormTypes.Todo>> = ({
  connect,
  values,
  expandableStepProps,
}) => <CostForwardingSection connect={connect} values={values} expandableStepProps={expandableStepProps} />;

export default ReceiptTodoCostForwardingSection;
